import { assert_string_uuid } from '@shared/asserts/utils_asserts_string';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { MAP__fields_by_id } from '@shared/types/types';
import { FIELD__base } from './FIELD__base';

declare module './FIELD__base' {
  interface FIELD__base {
    // key - id
    fields__get_map(with_children: boolean): MAP__fields_by_id;

    fields__get_by_type<T extends FIELD__base>(ctor: new (...args: any[]) => T): T[];
  }
}

export function INIT_EXTENSION_FIELD_BASE__field() {
  // do nothing
}

/*
 *
 */

// key - id
FIELD__base.prototype.fields__get_map = function (with_children: boolean): MAP__fields_by_id {
  let out: MAP__fields_by_id = new MAP__serializable();

  let fields_list = Object.values(this).filter(field => field instanceof FIELD__base);

  for (let field of fields_list) {
    assert_string_uuid(field.meta.field_id);

    out.set(field.meta.field_id, field);

    if (!with_children) continue;

    let fields_list_children = field.fields__get_map(true);
    out.merge_with(fields_list_children);
  }

  return out;
};

FIELD__base.prototype.fields__get_by_type = function <T extends FIELD__base>(ctor: new (...args: any[]) => T): T[] {
  let out: T[] = [];

  for (const [_, field] of this.fields__get_map(true).entries()) {
    if (field instanceof ctor) out.push(field as T);
  }

  return out;
};
